import React from 'react';
import PropTypes from 'prop-types';
import {Paper} from 'material-ui';
import Dropzone from 'react-dropzone';
import styles from './ApplicationInfo.css';
import {Avatar} from "material-ui";
import defaultAppPicture from '../../../../resources/images/application/Application2.svg';
import {black} from "material-ui/styles/colors";
import {List, ListItem} from 'material-ui/List';
import AddBox from 'material-ui/svg-icons/content/add-box';
import Edit from 'material-ui/svg-icons/content/create';
import Translate from 'material-ui/svg-icons/action/translate';
import withTranslation from "../../../../hoc/withTranslation";

const Timestamp = require('react-timestamp');

class ApplicationInfo extends React.Component {
    static propTypes = {
        app: PropTypes.object.isRequired,
        postPicture: PropTypes.func.isRequired
    };

    static supportedDropFiles = 'image/jpeg, image/png';

    handlePictureDrop = (accepted, rejected) => {
        this.setState({uploadingFiles: []});

        accepted.forEach((picture) => {
            console.log('Uploading file ' + picture.name);
            this.props.postPicture(this.props.app.id, picture, (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                const uploadingState = this.state.uploadingFiles.filter((mediaPercent) => mediaPercent.media !== picture);
                console.log(picture.name + ' -> ' + percentCompleted + '% (' + progressEvent.loaded + ' / ' + progressEvent.total + ')');
                this.setState({
                    uploadingFiles: [
                        ...uploadingState,
                        {
                            picture: picture,
                            percent: percentCompleted
                        }
                    ]
                });
            });
        });
    };

    render() {
        let image;
        if (this.props.app.picture) {
            image = this.props.app.picture;
        } else {
            image = defaultAppPicture;
        }

        let selfavatarstyles;
        if (this.props.app.primary_color) {
            selfavatarstyles = {
                ...styles.avatar,
                backgroundColor: this.props.app.primary_color
            };
        } else {
            selfavatarstyles = {
                ...styles.avatar
            };
        }
        let primaryIconStyle = {
            ...styles.listIcon,
            backgroundColor: this.props.app.primary_color
        };
        let secondaryIconStyle = {
            ...styles.listIcon,
            backgroundColor: this.props.app.secondary_color
        };
        return (
            <Paper style={styles.box}>
                <Dropzone
                    ref={(node) => {
                        this.dropzoneRef = node
                    }}
                    accept={ApplicationInfo.supportedDropFiles}
                    onDrop={this.handlePictureDrop}
                    multiple={false}
                    style={styles.dropzone}
                >
                    <Avatar src={image}
                            size={75}
                            style={selfavatarstyles}/>
                </Dropzone>
                <h1 style={styles.header}>
                    {this.props.app.name}
                </h1>
                <h2 style={styles.headerspan}>
                    {this.props.app.id}
                </h2>
                <List>
                    <ListItem
                        style={styles.list}
                        disabled={true}
                        primaryText={this.props.t('page_app.primary_color')}
                        secondaryText={this.props.app.primary_color}
                        leftIcon={<div style={primaryIconStyle}/>}/>
                    <ListItem
                        style={styles.list}
                        disabled={true}
                        primaryText={this.props.t('page_app.secondary_color')}
                        secondaryText={this.props.app.secondary_color}
                        leftIcon={<div style={secondaryIconStyle}/>}/>
                    <ListItem
                        style={styles.list}
                        disabled={true}
                        primaryText={this.props.t('page_app.default_lang')}
                        secondaryText={this.props.app.default_language || this.props.t('generic.set_never')}
                        leftIcon={<Translate color={black}/>}/>
                    <ListItem
                        style={styles.list}
                        disabled={true}
                        primaryText={this.props.t('generic.created_at')}
                        secondaryText={<Timestamp time={this.props.app.created_at} format='full' twentyFourHour/>}
                        leftIcon={<AddBox color={black}/>}/>
                    <ListItem
                        style={styles.list}
                        disabled={true}
                        primaryText={this.props.t('generic.updated_at')}
                        secondaryText={
                            (
                                this.props.app.updated_at &&
                                <Timestamp time={this.props.app.updated_at} format='full' twentyFourHour/>
                            )
                            || this.props.t('generic.updated_never')}
                        leftIcon={<Edit color={black}/>}/>
                </List>
            </Paper>
        );
    }
}

export default withTranslation(ApplicationInfo);



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ApplicationInfo/ApplicationInfo.js